<template>
  <div v-if="getCartItemsCount > 0" class="item_count">
    <p>{{ getCartItemsCount }}</p>
  </div>
</template>

<script>
  export default {
    name: "MiniCart",

    props: [
      'count',
      'items',
      'total_price',
      'subtotal_price',
      'total_without_pdv',
      'pdv',
      'coupon'
    ],

    created() {

      // Set initial value of cart items in shopping-cart in vuex store...
      this.$store.dispatch('Cart/changeItemCount', this.count);
      this.$store.dispatch('Cart/changeCartItems', this.items);
      this.$store.dispatch('Cart/changeTotalPrice', this.total_price);
      this.$store.dispatch('Cart/changeSubTotalPrice', this.subtotal_price);
      this.$store.dispatch('Cart/changeTotalWithoutPDV', this.total_without_pdv);
      this.$store.dispatch('Cart/changeTotalPDV', this.pdv);
      this.$store.dispatch('Cart/changeCoupon', this.coupon);
      this.$store.dispatch('Cart/changeSideCart', false);

    },

    computed: {

      /**
       * Retrieve cart items from vuex store
       * That means on every change of vuex state, retrieve changes...
       */
      getCartItems() {

        return this.$store.getters['Cart/getCartItems'];
      },

      /**
       * Retrieve cart items count from vuex store
       */
      getCartItemsCount() {
        return this.$store.getters['Cart/getItemCount'];
      },

      /**
       * Retrieve cart items total price from vuex store
       */
      getTotalPrice() {
        return this.$store.getters['Cart/getTotalPrice'];
      },

      /**
       * Retrieve cart items sub-total price from vuex store
       */
      getSubTotalPrice() {
        return this.$store.getters['Cart/getSubTotalPrice'];
      },

      /**
       * Retrieve cart items total price without pdv from vuex store
       */
      getTotalWithoutPDV() {
        return this.$store.getters['Cart/getTotalWithoutPDV'];
      },

      /**
       * Retrieve cart items total pdv from vuex store
       */
      getTotalPDV() {
        return this.$store.getters['Cart/getTotalPDV'];
      },

      /**
       * Retrieve coupons code and total discount
       */
      getCoupon() {
        return this.$store.getters['Cart/getCoupon'];
      },

      /**
       * Retrieve sideCart status
       */
      getSideCart() {
        return this.$store.getters['Cart/getSideCart'];
      }
    },

    methods: {
      /**
       * Change vuex state to close side cart.
       */
      openSideCart() {
        this.$store.dispatch('Cart/changeSideCart', true);
      }
    }

  }
</script>

<style scoped>
.item_count {
  margin: 0.5rem auto;
}
</style>
